import { render, staticRenderFns } from "./AssignedToList.vue?vue&type=template&id=48d82346&scoped=true"
import script from "./AssignedToList.vue?vue&type=script&lang=js"
export * from "./AssignedToList.vue?vue&type=script&lang=js"
import style0 from "./AssignedToList.vue?vue&type=style&index=0&id=48d82346&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d82346",
  null
  
)

export default component.exports